/*
 * @Author: 向南星 xiangnanxing@scmagic.cn
 * @Date: 2022-09-19 13:56:15
 * @LastEditors: 向南星 xiangnanxing@scmagic.cn
 * @LastEditTime: 2022-11-08 10:43:22
 */
import React, { forwardRef } from 'react';
import { areEqual, FixedSizeList, ListChildComponentProps } from 'react-window';
import { useRecoilValue } from 'recoil';
import { useOpenPopup } from 'src/modules/imagesV3/hooks/useOpenPopup';
import {
  materialItemSelector,
  myPropsListSelector
} from 'src/modules/imagesV3/store/selector';
import EmptyPlaceholder from '../../EmptyPlaceholder';
import ImageButton from '../../ImageButton';
import BaseListItem from '../BaseListItem';
import { LIST_HEIGHT, RATIO, LIST_WIDTH } from '../list';
import styles from './index.module.scss';

const calcStyle = (style: any) => {
  return {
    ...style,
    top: `${parseFloat(style.top) + 10 * RATIO}px`
  };
};

const Row = React.memo(
  ({ index, style, data }: ListChildComponentProps<number[]>) => {
    const item = useRecoilValue(materialItemSelector(data[index]));
    const openPopup = useOpenPopup();
    if (!item) return null;

    return (
      <div className={styles.wrapper} style={calcStyle(style)}>
        <BaseListItem
          logo={item.logo}
          title={item.title}
          desc={item.desc}
          count={item.number}
          placeholder="不可转赠"
          buttons={[
            item.composeList.length > 0 && (
              <ImageButton
                type="primary"
                onClick={() => openPopup('propCompose', item.toolId)}
              >
                合成
              </ImageButton>
            ),
            item.canSend && item.number > 0 && (
              <ImageButton
                type="primary"
                onClick={() => openPopup('present', item.toolId)}
              >
                赠送
              </ImageButton>
            )
          ]}
        />
      </div>
    );
  },
  areEqual
);

const InnerElementType: React.FC = forwardRef<any, any>(
  ({ style, ...rest }, ref) => (
    <div
      ref={ref}
      style={{
        ...style,
        height: `${parseFloat(style.height) + 30 * RATIO}px`
      }}
      {...rest}
    />
  )
);

const MyPropsList: React.FC = () => {
  const list = useRecoilValue(myPropsListSelector);
  if (list.length === 0) return <EmptyPlaceholder />;
  return (
    <FixedSizeList
      height={LIST_HEIGHT}
      itemCount={list.length}
      itemData={list}
      itemSize={280 * RATIO}
      width={LIST_WIDTH}
      className={styles.container}
      innerElementType={InnerElementType}
    >
      {Row}
    </FixedSizeList>
  );
};

export default React.memo(MyPropsList);
